import { CognitoUserPool } from 'amazon-cognito-identity-js';
const poolData = {
    UserPoolId: 'us-east-1_r7ztb5GkP',
    ClientId: '683flgj8gtgi4b80gho41mvhih'
};
/*
const poolData = {
    UserPoolId: 'us-east-1_7r6WdXe8O',
    ClientId: '15j82hsq9s1jfrlrsraoncnf6d'
};
*/

export default new CognitoUserPool(poolData);